// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3Dz6Q","content":"RecentSearches_content__3p1bY"};